<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>发票管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="item" class="search">
            <el-row>
                <el-form-item label="处理状态">
                    <el-radio-group v-model="item.type" @change="submit">
                        <el-radio-button label="0">全部发票</el-radio-button>
                        <el-radio-button label="1">待开发票</el-radio-button>
                        <el-radio-button label="2">已开发票</el-radio-button>
<!--                        <el-radio-button label="3">退款发票</el-radio-button>-->
                    </el-radio-group>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="订单号">
                    <el-input v-model="item.order_sn" placeholder="请输入订单号" size="small"></el-input>
                </el-form-item>
                <el-form-item label="用户">
                    <el-input v-model="item.buyer_name" placeholder="请输入昵称、手机号" size="small"></el-input>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit" size="medium">查询</el-button>
                </el-form-item>
            </el-row>
        </el-form>
        <el-table :data="list" border>
            <el-table-column prop="order_invoice_id" label="ID" width="80"></el-table-column>
            <el-table-column label="订单号" width="250">
                <template slot-scope="scope">
                    <span>{{scope.row.order ? scope.row.order.order_sn : ''}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="real_name" label="用户" width="120">
                <template slot-scope="scope">
                    <div class="avatar">
                        {{scope.row.nick_name}}[{{scope.row.user_id}}]
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="订单金额">
                <template slot-scope="scope">
                    {{scope.row.order.order_price}} 元
                </template>
            </el-table-column>
            <el-table-column label="发票抬头类型">
                <template slot-scope="scope">
                    <template v-if="scope.row.header_type == 1">个人</template>
                    <template v-else>企业</template>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="开票时间"></el-table-column>
            <el-table-column prop="name" label="开票状态">
                <template slot-scope="scope">
                    <el-tag size="small" effect="dark" type="danger" v-if="scope.row.is_invoice == 1">已开票</el-tag>
                    <el-tag size="small" effect="dark" type="warning" v-else>未开票</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="订单状态">
                <template slot-scope="scope">
                    {{scope.row.order.state_text}}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="primary" @click="orderInfo(scope.row.order_id)">订单信息</el-button>
                </template>
            </el-table-column>
        </el-table>
        <Modal v-model="invoiceShow" scrollable title="发票详情" class="order_box" width="700" @on-cancel="cancel" footer-hide>
            <Form ref="formInline" :model="formInline" :label-width="100" @submit.native.prevent>
                <div v-if="invoiceDetails.header_type===1 && invoiceDetails.type===1">
                    <div class="list">
                        <div class="title">发票信息</div>
                        <Row class="row">
                            <Col span="12">发票抬头: <span class="info">{{invoiceDetails.name}}</span></Col>
                            <Col span="12">发票类型: <span class="info">电子普通发票</span></Col>
                        </Row>
                        <Row class="row">
                            <Col span="12">发票抬头类型: 个人</Col>
                        </Row>
                    </div>
                    <div class="list">
                        <div class="title row">联系信息</div>
                        <Row  class="row">
                            <Col span="12">真实姓名: {{invoiceDetails.real_name}}</Col>
                            <Col span="12">联系电话: {{invoiceDetails.user_phone}}</Col>
                        </Row>
                        <Row  class="row">
                            <Col span="12">联系邮箱: {{invoiceDetails.email}}</Col>
                        </Row>
                    </div>
                </div>
                <div v-if="invoiceDetails.header_type===2 && invoiceDetails.type===1">
                    <div class="list">
                        <div class="title">发票信息</div>
                        <Row class="row">
                            <Col span="12">发票抬头: <span class="info">{{invoiceDetails.name}}</span></Col>
                            <Col span="12">企业税号: <span class="info">{{invoiceDetails.duty_number}}</span></Col>
                        </Row>
                        <Row class="row">
                            <Col span="12">发票类型: 电子普通发票</Col>
                            <Col span="12">发票抬头类型: 企业</Col>
                        </Row>
                    </div>
                    <div class="list">
                        <div class="title row">联系信息</div>
                        <Row  class="row">
                            <Col span="12">真实姓名: {{invoiceDetails.real_name}}</Col>
                            <Col span="12">联系电话: {{invoiceDetails.user_phone}}</Col>
                        </Row>
                        <Row  class="row">
                            <Col span="12">联系邮箱: {{invoiceDetails.email}}</Col>
                        </Row>
                    </div>
                </div>
                <div v-if="invoiceDetails.header_type===2 && invoiceDetails.type===2">
                    <div class="list">
                        <div class="title">发票信息</div>
                        <Row class="row">
                            <Col span="12">发票抬头: <span class="info">{{invoiceDetails.name}}</span></Col>
                            <Col span="12">企业税号: <span class="info">{{invoiceDetails.duty_number}}</span></Col>
                        </Row>
                        <Row class="row">
                            <Col span="12">发票类型: 纸质专用发票</Col>
                            <Col span="12">发票抬头类型: 企业</Col>
                        </Row>
                        <Row class="row">
                            <Col span="12">开户银行: <span class="info">{{invoiceDetails.bank}}</span></Col>
                            <Col span="12">银行账号: <span class="info">{{invoiceDetails.card_number}}</span></Col>
                        </Row>
                        <Row class="row">
                            <Col span="12">企业地址: {{invoiceDetails.address}}</Col>
                            <Col span="12">企业电话: {{invoiceDetails.tell}}</Col>
                        </Row>
                    </div>
                    <div class="list">
                        <div class="title row">联系信息</div>
                        <Row  class="row">
                            <Col span="12">真实姓名: {{invoiceDetails.real_name}}</Col>
                            <Col span="12">联系电话: {{invoiceDetails.user_phone}}</Col>
                        </Row>
                        <Row  class="row">
                            <Col span="12">联系邮箱: {{invoiceDetails.email}}</Col>
                        </Row>
                    </div>
                </div>
                <FormItem label="开票状态：" style="margin-top: 14px;">
                    <RadioGroup v-model="formInline.is_invoice" @on-change="kaiInvoice(formInline.is_invoice)">
                        <Radio :label=1>已开票</Radio>
                        <Radio :label=0>未开票</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="发票编号：" v-if="formInline.is_invoice===1">
                    <Input v-model="formInline.invoice_number" placeholder="请输入发票编号"></Input>
                </FormItem>
                <FormItem label="发票备注：" v-if="formInline.is_invoice===1">
                    <Input v-model="formInline.remark" value="备注" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入发票备注"></Input>
                </FormItem>
                <FormItem label="电子发票：" v-if="formInline.is_invoice===1">
                    <div style="display: flex;align-items: center">
                        <Input
                                v-model="formInline.file"
                                placeholder=""
                                disabled
                                v-width="'50%'"/>
                        <uploadfile :type="'pdf'" :format="['pdf']" @uploadSuccess="uploadSuccess"></uploadfile>
                    </div>
                </FormItem>
                <Button type="primary" @click="handleSubmit()" style="width: 100%;margin: 0 10px;">确定</Button>
            </Form>
        </Modal>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    import uploadfile from '@/components/uploadfile/index';

    export default {
        components: {
            uploadfile
        },
        data() {
            return {
                list: [],
                isLoad: false,
                pageSize: 20,
                page: 1,
                total: 0,
                item: {
                    type: '1'
                },
                orderShow: false,
                invoiceShow: false,
                invoiceDetails: {},
                formInline: {
                    is_invoice: 0,
                    invoice_number: '',
                    remark: ''
                },
            }
        },
        created() {
            this.loadList();
        },
        methods: {
            // 搜索查询
            submit() {
                this.page = 1
                this.loadList()
            },
            loadList() {
                this.isLoad = true
                this.axios.get('store/order.invoice/list', {
                    params: Object.assign({
                        page: this.page,
                        pagesize: this.pageSize
                    }, this.item)
                }).then(res => {
                    this.isLoad = !this.isLoad
                    this.list = res.data.list.data
                    this.total = res.data.list.total
                    this.isLoad = false
                })
            },
            sizeReload(val) {
                this.page = 1
                this.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            },
            empty () {
                this.formInline = {
                    is_invoice: 1,
                    invoice_number: '',
                    remark: ''
                };
            },
            cancel () {
                this.invoiceShow = false;
                this.empty();
            },
            edit (row) {
                this.invoiceShow = true;
                this.invoiceDetails = row;
                this.formInline.invoice_number = row.invoice_number;
                this.formInline.remark = row.remark;
                this.formInline.file = row.file;
                this.formInline.is_invoice = row.is_invoice;
            },
            orderInfo(id) {
                this.$router.push({
                    path: '/Indent/list.html',
                    query: {
                        id: id
                    }
                });
            },
            uploadSuccess: function (res) {
                this.formInline.file = res.external_url
            },
            handleSubmit () {
                if (this.formInline.is_invoice === 1) {
                    if (this.formInline.invoice_number.trim() === '') return this.$Message.error('请填写发票编号');
                }
                this.axios.post('store/order.invoice/set', Object.assign({
                    order_invoice_id: this.invoiceDetails.order_invoice_id
                }, this.formInline)).then(res => {
                    if (res.code == 1) {
                        this.$Message.success(res.msg);
                        this.invoiceShow = false;
                        this.loadList();
                        this.empty();
                    } else {
                        this.$Message.error(res.msg);
                    }
                }).catch(err => {
                    this.$Message.error(err.msg);
                })
            },
        }
    }
</script>
<style scoped lang="less">
    .order_box .list{
        font-size: 12px;
        color: #17233D;
        border-bottom: 1px solid #E7EAEC;
        margin: 0 10px;
        padding-bottom :22px;
    }
    .ivu-form-item{
        margin-left: 10px;
        margin-right: 10px;
    }
    /deep/.ivu-form-item-label{
        text-align: left;
        width: 83px!important;
    }
    /deep/.ivu-form-item-content{
        margin-left: 83px!important
    }
    .order_box .list .title{
        color: #000000;
        font-weight: bold;
    }
    .order_box .list .row{
        margin-top: 13px;
    }
    .order_box .list .info{
        color: #515A6E;
    }
</style>
